import { LocalizedString } from "../../generated/platform";
import { Locale } from "../api/model";

export const getLocalizedValue = (
  locale: Locale,
  localized?: LocalizedString | null
) =>
  localized
    ? (localized as {
        [key: string]: any;
      })[locale]
    : "";
